import { SnackbarOrigin } from 'notistack'

/**
 * Where an action's own feedback appears.
 *
 * NotistackProvider's default is top-right, which suits background notices. A
 * snackbar answering something the user just submitted is centred instead, so it
 * lands where they are already looking rather than in the corner.
 *
 * Shared because it was being redeclared verbatim in every screen that needed
 * it — four, at the point this was extracted.
 */
export const SNACKBAR_ANCHOR: SnackbarOrigin = {
  vertical: 'top',
  horizontal: 'center',
}
